import './index.scss';
import CumlativePayoutReport from './CumlativePayoutReport';

function PayoutReportTab() {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '24px' }}>
      <CumlativePayoutReport />
    </div>
  );
}

export default PayoutReportTab;
